import { useFetch } from './useFetch';
import { BffUrl } from '@portal/lib';

export const useBulkUpload = ({
  errorText,
  isErrorAlertMuted = false,
  onError,
  onSuccess,
}) => {
  const [fetch, fetchRes] = useFetch({
    errorText,
    isErrorAlertMuted,
    onError,
    onSuccess,
  });

  const bulkUpload = async ({ leadType, storeId, file }) => {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('lead_type', leadType);
    formData.append('store_id', storeId);

    const config = {
      method: 'post',
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      url: `${BffUrl}/api/bus-service-handler`,
      data: formData,
    };

    return await fetch(config);
  };

  return [bulkUpload, fetchRes];
};
